export default "__VITE_ASSET__BgsrQ8sp__"